import FormatPriceTVOD from "@/components/FormatPriceTVOD";
import dayjs from "@/lib/day";
import { jsx as _jsx } from "react/jsx-runtime";
export function price(item) {
  var rights = item.rights;
  var prices = rights.map(function (right) {
    return right.price;
  });
  var price = prices.reduce(function (a, b) {
    return Math.min(a, b);
  });
  var ext = prices.length > 1 ? "から" : null;
  return /*#__PURE__*/_jsx(FormatPriceTVOD, {
    price: price,
    ext: ext
  });
}
export function deliveryDate(item) {
  var onlyStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!item) return null;
  var start = "delivery_start_at";
  var end = "delivery_end_at";
  if (!item[start]) return null;
  var startAt = dayjs(new Date(item[start]));
  var format = "YYYY/M/D";
  var deliveryDate = "".concat(startAt.format(format), " -");

  if (item[end] && !onlyStart) {
    var endAt = dayjs(new Date(item[end]));
    deliveryDate = "".concat(deliveryDate, " ").concat(endAt.format(format));
  }

  return deliveryDate;
}
export function deliveryLabel(item) {
  if (!item) return null;
  if (item.__typename !== "EpisodeMeta") return null;
  var now = dayjs();
  var deliveryStart = dayjs(new Date(item.delivery_start_at));
  var deliveryEnd = dayjs(new Date(item.delivery_end_at));
  var delivery = false;

  if (item.delivery_start_at && item.delivery_end_at) {
    delivery = now.isBetween(deliveryStart, deliveryEnd, null, "[)");
  } else if (item.delivery_start_at && !item.delivery_end_at) {
    delivery = now.isSameOrAfter(deliveryStart);
  } else if (!item.delivery_start_at && item.delivery_end_at) {
    delivery = now.isBefore(deliveryEnd);
  }

  if (delivery && item.delivery_end_at && deliveryEnd.diff(now, "hours") < 72) {
    return "まもなく配信終了";
  } else if (!delivery && deliveryStart.isAfter(now)) {
    return "配信前";
  }

  return null;
}
export function liveStatus(item) {
  if (!item) return null;
  if (item.__typename !== "LiveMeta") return null;
  var now = dayjs();
  var encodeStart = dayjs(new Date(item.encode_start_date));
  var encodeEnd = dayjs(new Date(item.encode_end_date));
  var status = false;

  if (item.encode_start_date && item.encode_end_date) {
    status = now.isBetween(encodeStart, encodeEnd, null, "[)");
  } else if (item.encode_start_date && !item.encode_end_date) {
    status = now.isSameOrAfter(encodeStart);
  } else if (!item.encode_start_date && item.encode_end_date) {
    status = now.isBefore(encodeEnd);
  }

  return status;
}
export function liveStatusLabel(item) {
  var status = liveStatus(item);
  var now = dayjs();
  var encodeStart = dayjs(new Date(item.encode_start_date));
  if (status == null) return null;

  if (status) {
    return "LIVE";
  } else if (item.encode_start_date && encodeStart.isAfter(now)) {
    return "配信前";
  } else {
    return "";
  }
}
export function liveStartDate(item) {
  var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!item || !item.encode_start_date) return null;

  if (expanded) {
    return dayjs(item.encode_start_date).format("YYYY M/D H:mm 開始");
  } else {
    return dayjs(item.encode_start_date).format("M/D H:mm 開始");
  }
}
export function channelTag(item) {
  var tag = [];

  if (item.live_flag) {
    tag.push("ライブ配信");
  }

  if (item.video_flag) {
    tag.push("オンデマンド");
  }

  return tag.join(" + ");
}
export function isEnded(endDate) {
  if (typeof endDate == "undefined" || endDate == "" || endDate == null) {
    return false;
  }

  return dayjs().isAfter(dayjs(new Date(endDate)));
}